import { render, staticRenderFns } from "./OfficeInformationPreviewProvider.vue?vue&type=template&id=227078a2&scoped=true&"
import script from "./OfficeInformationPreviewProvider.vue?vue&type=script&lang=ts&"
export * from "./OfficeInformationPreviewProvider.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeInformationPreviewProvider.vue?vue&type=style&index=0&id=227078a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227078a2",
  null
  
)

export default component.exports